import {
    FacilityNurseDefaultRatesDetailsDto,
    FacilityNurseDefaultRatesDto,
} from '@clh/api-client';
import { dollarsToCents } from '@clh/util';

type Amount = number | null | undefined;

export type DefaultRatesFormValues = {
    hourlyRate: Amount;
    onCallRate: Amount;
    callbackRate: Amount;
    travelStipendEnabled: boolean;
    travelStipendAmount: Amount;
    travelStipendMinimumDistance: Amount;
};

const centsToDollars = (cents: number | null) =>
    cents === null ? null : cents / 100;

export const toFormValues = (
    rates: FacilityNurseDefaultRatesDetailsDto
): DefaultRatesFormValues => ({
    hourlyRate: centsToDollars(rates.hourlyRate),
    onCallRate: centsToDollars(rates.onCallRate),
    callbackRate: centsToDollars(rates.callbackRate),
    travelStipendEnabled: rates.travelStipendEnabled,
    travelStipendAmount: centsToDollars(rates.travelStipendAmount),
    travelStipendMinimumDistance: rates.travelStipendMinimumDistance,
});

export const toDefaultRatesDto = (
    values: DefaultRatesFormValues
): FacilityNurseDefaultRatesDto => ({
    hourlyRate: dollarsToCents(values.hourlyRate),
    onCallRate: dollarsToCents(values.onCallRate),
    callbackRate: dollarsToCents(values.callbackRate),
    travelStipendEnabled: values.travelStipendEnabled,
    travelStipendAmount: dollarsToCents(values.travelStipendAmount),
    travelStipendMinimumDistance: values.travelStipendMinimumDistance ?? null,
});
